import React, { Component } from "react";
import { connect } from "react-redux";
import { actualizarMensaje, mostrarModulo } from "../../redux/actions/actGlobal";
import MenuGestion from "./gestion/MenuGestion";
import ConsultaSeguimiento from "./gestion/ConsultaSeguimiento";
import AnalisisInformacion from "./gestion/AnalisisInformacion";

class GestionProyectoVida extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accion: "consulta", // 'consulta' | 'analisis'
    };
  }

  componentDidMount() {
    let { mostrarModulo } = this.props;
    mostrarModulo({ ruta: "/gestion_proyectos_de_vida", nombre: "Gestión Proyectos de Vida" });
  }

  render() {
    let { accion } = this.state;
    let { actualizarMensaje } = this.props;
    return (
      <div>
        <MenuGestion sele={accion} seleccionar={(accion) => this.setState({ accion })} />
        <div className="contenido_modulo">
          {accion === "consulta" && <ConsultaSeguimiento actualizarMensaje={actualizarMensaje} />}
          {accion === "analisis" && <AnalisisInformacion actualizarMensaje={actualizarMensaje} />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  return { usuario };
};

const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo,
};

export default connect(mapStateToProps, mapDispatchToProps)(GestionProyectoVida);
